import dayjs from 'dayjs'
import axios from 'axios'
import bowser from 'bowser'
const removeMd = require('remove-markdown')

export const getUrlParameter = (urlPath = window.location.search, name) => {
	name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
	var results = regex.exec(urlPath)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const log = function () {
	const debug = getUrlParameter(window.location.search, '__sbdebug') || ''
	if (debug !== 'yes') return
	window.console.log(...arguments)
}

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export const getTimezone = () => {
	let offset = new Date().getTimezoneOffset()
	let hours = Math.floor(Math.abs(offset) / 60)
	let minutes = Math.floor(Math.abs(offset) % 60)

	// The time-zone offset is the difference, in minutes, between UTC and local time
	const sign = offset < 0 ? '+' : '-'

	if (hours < 10) {
		hours = '0' + hours
	}

	if (minutes < 10) {
		minutes = '0' + minutes
	}

	return `${sign}${hours}:${minutes}`
}

export const absURL = path => {
	const prefixURL = trim(process.env.VUE_APP_FILE_URL, '/')
	let newPath = trim(path)
	newPath = newPath.replace(prefixURL, '')
	newPath = trimStart(newPath, '/')

	if (!newPath) return ''
	if (startsWith(newPath, 'http')) return newPath

	return `${prefixURL}/${newPath}`
}

export const getIntegrationId = accid => `${accid}.subizv4.subikon`

export const attributeType = ['text', 'number', 'list', 'datetime', 'boolean']

export const getMs = function (t) {
	if (typeof t !== 'number') t = new Date(t).getTime()

	if (t > 1e18) {
		// nanoseconds
		return t / 1e6
	}
	if (t > 1e15) {
		// microseconds
		return t / 1e3
	}
	if (t > 1e12) {
		// milliseconds
		return t
	}
	return t * 1e3 // seconds
}

export const isValidLanguage = code => {
	const allowLanguages = ['en', 'vi', 'en-US', 'vi-VN']
	return !isEmpty(code) && allowLanguages.indexOf(code) >= 0
}

export const sendEventToThirdParty = (g_client, category, action, label) => {
	g_client.call('track_ga', category, action, label)
	g_client.call('track_fb', category, action, label)
}

export const isAttributeEmpty = attr => {
	let exits = true
	attributeType.forEach(a => {
		if (typeof attr[a] === 'undefined' || !attr[a]) {
			exits = false
		}
	})
	return exits
}

export const isEmail = email => {
	var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i // eslint-disable-line
	return re.test(String(email).toLowerCase())
}

var toString = Object.prototype.toString
export const isNumber = value => !isNaN(value) && toString.call(value) === '[object Number]'

export const isToday = t => new Date().toDateString() === new Date(t || 0).toDateString()

export const isYesterday = t => {
	var date = new Date()
	date.setDate(date.getDate() - 1)
	return date.toDateString() === new Date(t || 0).toDateString()
}

export const truncate = (s, length, omission, separator) => {
	length = length || 30
	omission = omission || '...'

	s = s || ''

	if (length >= s.length) return s

	let end = length - (omission.length || 0)
	if (end < 1) return omission

	let result = s.slice(0, end)

	if (separator === undefined) return result + omission

	if (s.indexOf(separator, end) !== end) {
		const index = result.lastIndexOf(separator)
		if (index > -1) result = result.slice(0, index)
	}
	return result + omission
}

export const isEmpty = o => {
	if (!o) return true
	for (var k in o) if (o.hasOwnProperty(k)) return false
	return true
}

export const size = o => {
	if (!o) return 0
	if (o.length !== undefined) return o.length
	return Object.keys(o).length
}

const trim = (s, suffix) => {
	s = ((s || '') + '').replace(new RegExp((suffix || ' ') + '*$'), '')
	return trimStart(s, suffix)
}

const trimStart = (s, prefix) => {
	s = (s || '') + ''
	while (s.charAt(0) === prefix) s = s.substr(1)
	return s
}

export const cloneDeep = o => JSON.parse(JSON.stringify(o))

export const find = (a, f) => a[findIndex(a, f)]

export const findIndex = (a, f) => {
	var found = -1
	a.forEach((v, i) => {
		if (found !== -1) return
		if (f(v)) found = i
	})
	return found
}

export const unionBy = (...args) => {
	var k = args.pop()
	var c = {}
	var cs = []
	for (let a of args) {
		for (let i in a) if (a.hasOwnProperty(i)) c[a[i][k]] = a[i]
	}
	for (let i in c) if (c.hasOwnProperty(i)) cs.push(c[i])
	return cs
}

export const orderBy = (a, k, d) => {
	var clone = []
	for (var i in a) if (a.hasOwnProperty(i)) clone.push(a[i])
	clone.sort((i, j) => {
		if (i[k] === j[k]) return 0
		var r = i[k] < j[k] ? -1 : 1
		return d === 'desc' ? -r : r
	})
	return clone
}

export const showDateTime = (time, dateFormat) => {
	let timeMs = getMs(time)
	if (isToday(timeMs)) {
		return dayjs(timeMs).format('HH:mm')
	}
	return dayjs(timeMs).format(dateFormat)
}

export const windowIsHidden = _ =>
	!!(document.hidden || document.webkitHidden || document.msHidden || document.mozHidden)

export const capitalize = value => {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
}

export const removeMarkdown = text => removeMd(text, { useImgAltText: false })

export const parseViewportContent = content => {
	let originViewport = {}
	content = content.replace(/([^\s,;]+)(?:[\s]*)?=(?:[\s]*)?([^\s,;]*?)/gi, '$1=$2')
	content = content.replace(/([,;])/gi, ' ')
	content = content.replace(/([\s]+)/gi, ' ')

	const contentParts = content.split(' ')
	for (let contentPart of contentParts) {
		contentPart = contentPart.trim()
		if (contentPart === '') {
			continue
		}

		const parts = contentPart.split('=')
		if (parts.length < 2) {
			continue
		}

		let [field, value] = parts
		field = field.trim()
		value = value.trim()
		originViewport[field] = value
	}
	return originViewport
}

export const getCSS = async url => {
	const resp = await axios.get(url, { withCredentials: false })
	return resp.data
}

export const getLanguageByCode = async (prefixURL, code) => {
	const resp = await axios.get(`${prefixURL}/${code}`, {
		withCredentials: false,
	})
	return resp.data
}

export const getLanguage = async url => {
	const resp = await axios.get(url, { withCredentials: false })
	return resp.data
}

export const mergeLanguage = (base, custom) => {
	return Object.assign({}, cloneDeep(base), cloneDeep(custom))
}

export const startsWith = (s, i) => ((s || '') + '').startsWith(i)

export const EMOJI_LIST = [
	'like',
	'unlike',
	'wink',
	'tongue-out',
	'tired',
	'surprised',
	'smiling',
	'sleepy',
	'sad',
	'neutral',
	'heart-eyes',
	'grinning',
	'crying',
	'confused',
	'angry',
]

export const excludeBots = agents => agents.filter(a => a.type !== 'bot')

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
export const throttle = (func, wait, options) => {
	var context, args, result
	var timeout = null
	var previous = 0
	if (!options) options = {}
	var later = function () {
		previous = options.leading === false ? 0 : Date.now()
		timeout = null
		result = func.apply(context, args)
		if (!timeout) context = args = null
	}
	return function () {
		var now = Date.now()
		if (!previous && options.leading === false) previous = now
		var remaining = wait - (now - previous)
		context = this
		args = arguments
		if (remaining <= 0 || remaining > wait) {
			if (timeout) {
				clearTimeout(timeout)
				timeout = null
			}
			previous = now
			result = func.apply(context, args)
			if (!timeout) context = args = null
		} else if (!timeout && options.trailing !== false) {
			timeout = setTimeout(later, remaining)
		}
		return result
	}
}

export const debounce = (func, wait, immediate) => {
	// 'private' variable for instance
	// The returned function will be able to reference this due to closure.
	// Each call to the returned function will share this common timer.
	var timeout

	// Calling debounce returns a new anonymous function
	return function () {
		// reference the context and args for the setTimeout function
		var context = this
		var args = arguments

		// Should the function be called now? If immediate is true
		//   and not already in a timeout then the answer is: Yes
		var callNow = immediate && !timeout

		// This is the basic debounce behaviour where you can call this
		//   function several times, but it will only execute once
		//   [before or after imposing a delay].
		//   Each time the returned function is called, the timer starts over.
		clearTimeout(timeout)

		// Set the new timeout
		timeout = setTimeout(function () {
			// Inside the timeout function, clear the timeout variable
			// which will let the next execution run when in 'immediate' mode
			timeout = null

			// Check if the function already ran with the immediate flag
			if (!immediate) {
				// Call the original function with apply
				// apply lets you define the 'this' object as well as the arguments
				//    (both captured before setTimeout)
				func.apply(context, args)
			}
		}, wait)

		// Immediate mode and no wait timer? Execute the function..
		if (callNow) func.apply(context, args)
	}
}

export const isValidPosition = position => {
	const positions = ['left', 'right']
	return !isEmpty(position) && positions.indexOf(position) >= 0
}

export const isValidWindowMode = windowMode => {
	if (bowser.mobile) return
	const windowModes = ['mini', 'full']
	return !isEmpty(windowMode) && windowModes.indexOf(windowMode) >= 0
}
